import { useEffect } from 'react';
import { Provider, useOfflineContext } from './Provider';
import OfflineQueue from './OfflineQueue';
import Callback from '../../Services/Callback';

const syncCompleteCallback = new Callback();

const offlineStatus = {
    PENDING: 'Pending',
    SYNCED: 'Synced',
    OFFLINE: 'Offline',
    SYNCING: 'Syncing',
    COMPLETE: 'Complete',
    ERROR: 'Error',
}

const Offline = (props) => {
    return <Provider {...props}>
        {props.children}
    </Provider>
};

const useSyncComplete = (callback) => {
    useEffect(
        () => syncCompleteCallback.listen(callback),
        [callback]
    );
}

export default Offline;

export {
    useOfflineContext as useOffline,
    OfflineQueue,
    offlineStatus,
    syncCompleteCallback,
    useSyncComplete,
}
